import React, { useState, useEffect } from 'react'
import { GoPlus } from 'react-icons/go'
import { FiMinus } from 'react-icons/fi'
import { IoReload } from 'react-icons/io5'
import { useTranslation } from 'react-i18next'
import { FaArrowDown, FaArrowUp } from 'react-icons/fa'

const RiskFinance = () => {
    const [calculationMode, setCalculationMode] = useState('Value') // "Value" or "Percentage"
    const [buyPrice, setBuyPrice] = useState('')
    const [numberOfShares, setNumberOfShares] = useState('')
    const [stopPriceCtrl, setStopPriceCtrl] = useState('')
    const [percentageInput, setPercentageInput] = useState('')
    const [currentPriceCtrl, setCurrentPriceCtrl] = useState('')
    const [results, setResults] = useState([])
    const [riskPercent, setRiskPercent] = useState(0)
    const [currentPricePercentage, setCurrentPricePercentage] = useState(0)
    const [risk, setRisk] = useState(0)
    const [riskStop, setRiskStop] = useState(0)
    const { t } = useTranslation()

    useEffect(() => {
        generateResults(
            buyPrice,
            numberOfShares,
            stopPriceCtrl,
            currentPriceCtrl,
            calculationMode,
            percentageInput
        )
    }, [
        buyPrice,
        numberOfShares,
        stopPriceCtrl,
        percentageInput,
        currentPriceCtrl,
        calculationMode,
    ])

    const generateResults = (
        buyPrice,
        shares,
        stopPrice,
        currentPrice,
        mode,
        percentage
    ) => {
        const parsedBuyPrice = parseFloat(buyPrice) || 0
        const parsedShares = parseInt(shares) || 0
        const parsedCurrentPrice = parseFloat(currentPrice) || 0
        const currentPricePercentage = (parsedCurrentPrice - parsedBuyPrice) / parsedBuyPrice * 100
        setCurrentPricePercentage(parseFloat(currentPricePercentage.toFixed(2)) || 0)


        let parsedStopPrice = parseFloat(stopPrice) || 0

        // If mode is Percentage, calculate stop price from the percentage input
        // if (mode === 'Percentage') {
        //     const parsedPercentage = parseFloat(percentage) || 0
        //     parsedStopPrice = parsedPercentage
        // }

        const riskPercentage =
            ((parsedStopPrice - parsedBuyPrice) / parsedBuyPrice) * 100
        const riskPrice = Math.round((parsedBuyPrice * parsedShares * riskPercentage) / 100)

        setRiskPercent(parseFloat(riskPercentage.toFixed(2)) || 0)
        setRisk(parseFloat(riskPrice.toFixed(2)) || 0)

        const percentages = [100, 75, 50, 25]
        const calculatedResults = []
        for (let i = 0; i < percentages.length; i++) {
            // const newShares = Math.floor(
            //     (((riskPercentage / 100) * (parsedBuyPrice * parsedShares)) /
            //         (parsedCurrentPrice - parsedStopPrice)) *
            //     -1 *
            //     (percentages[i] / 100)
            // )

            const newShares = i == 0 ? parsedShares : Math.round((parsedShares * percentages[i]) / 100)
            const gain = Math.ceil(
                newShares * parsedCurrentPrice - newShares * parsedBuyPrice
            )
            // const loss = Math.ceil(
            //     (parsedShares - newShares) * parsedStopPrice -
            //     (parsedShares - newShares) * parsedBuyPrice
            // )
            const loss = gain
            // const net = gain + loss
            const net = loss
            const netPercent = (net / (parsedBuyPrice * parsedShares)) * 100

            calculatedResults.push({
                onPercentRisk: percentages[i],
                newShares,
                gain: parseFloat(gain.toFixed(2)) || 0,
                loss: parseFloat(loss.toFixed(2)) || 0,
                net: parseFloat(net.toFixed(2)) || 0,
                netPercent: parseFloat(netPercent.toFixed(2)) || 0,
            })
        }

        setResults(calculatedResults)
    }

    // Handle increment and decrement of input values
    const handleIncrease = (setter, value) => {
        setter((prevValue) => (parseFloat(prevValue) + 0.1).toFixed(1))
    }

    const handleDecrease = (setter, value) => {
        setter((prevValue) => (parseFloat(prevValue) - 0.1).toFixed(1))
    }
    //
    const resetAllInput = () => {
        setBuyPrice('')
        setNumberOfShares('')
        setStopPriceCtrl('')
        setPercentageInput('')
        setCurrentPriceCtrl('')
        setRiskPercent(0)
        setRisk(0)
        setResults([])
    }
    return (
        <>
            <div className='mb-1'>
                <select
                    value={calculationMode}
                    onChange={(e) => setCalculationMode(e.target.value)}
                    className='w-full py-3 px-2 bg-[#171d33] text-white rounded-md focus:ring focus:ring-[#004f86] focus:outline-none'
                >
                    <option value='Value'>   {t("calculator.value")}</option>
                    <option value='Percentage'>   {t("calculator.percentage")}</option>
                </select>
            </div>

            <div className='mb-1'>
                <p className='text-sm font-medium text-white mb-1'>{t("calculator.buyPrice")}</p>
                <div className="flex group border border-transparent hover:border-[#2c3354] rounded-xl overflow-hidden transition-colors">
                    <input
                        type="number"
                        value={buyPrice}
                        onChange={(e) => setBuyPrice(e.target.value)}
                        className="w-full py-3 px-4 text-white bg-[#171d33] focus:outline-none custom-number-input"
                    />
                    <div className="flex items-center  justify-center bg-[#2c3354]">
                        <button
                            onClick={() => handleIncrease(setBuyPrice, buyPrice)}
                            className="text-white py-3 px-3 active:text-[#004f86] transition-colors"
                        >
                            <GoPlus size={19} />
                        </button>
                        <button
                            onClick={() => handleDecrease(setBuyPrice, buyPrice)}
                            className="text-white py-3 px-3 active:text-[#004f86] transition-colors"
                        >
                            <FiMinus size={19} />
                        </button>

                    </div>
                </div>
            </div>

            <div className='mb-1'>
                <p className='text-sm font-medium text-white mb-1'>
                    {t("calculator.numberOfShares")}
                </p>
                <div className="flex group border border-transparent hover:border-[#2c3354] rounded-xl overflow-hidden transition-colors">

                    <input
                        type='number'
                        value={numberOfShares}
                        onChange={(e) => setNumberOfShares(e.target.value)}
                        className="w-full py-3 px-4 text-white bg-[#171d33] focus:outline-none custom-number-input"
                    />
                    <div className="flex items-center  justify-center bg-[#2c3354]">

                        <button
                            onClick={() =>
                                handleIncrease(setNumberOfShares, numberOfShares)
                            }
                            className="text-white py-3 px-3 active:text-[#004f86] transition-colors"
                        >
                            <GoPlus size={19} />
                        </button>
                        <button
                            onClick={() =>
                                handleDecrease(setNumberOfShares, numberOfShares)
                            }
                            className="text-white py-3 px-3 active:text-[#004f86] transition-colors"
                        >
                            <FiMinus size={19} />
                        </button>
                    </div>
                </div>
            </div>

            {/* {calculationMode === 'Value' ? ( */}
            <div className="mb-1 ">


                <p className="text-sm font-medium text-white mb-1">  {t("calculator.stopLoss")}</p>
                <div className="flex group border border-transparent hover:border-[#2c3354] rounded-xl overflow-hidden transition-colors relative">
                    <input
                        type="number"
                        value={stopPriceCtrl}
                        onChange={(e) => setStopPriceCtrl(e.target.value)}
                        className="w-full py-3 px-4 text-white bg-[#171d33] focus:outline-none custom-number-input"
                    />
                    {isNaN(riskPercent) ? null :
                        <p
                            className={`absolute right-[21%] top-[26%] transform text-sm font-medium ${riskPercent < 0 ? 'text-red-500' : 'text-green-500'
                                }`}
                        >
                            <span className="flex items-center">
                                {riskPercent < 0 ? (
                                    <FaArrowDown size={14} className="mr-1" />
                                ) : (
                                    <FaArrowUp size={14} className="mr-1" />
                                )}
                                {Math.abs(riskPercent)}%
                            </span>
                        </p>
                    }
                    <div className="flex items-center justify-center bg-[#2c3354]">
                        <button
                            onClick={() => handleIncrease(setStopPriceCtrl, stopPriceCtrl)}
                            className="text-white py-3 px-3 active:text-[#004f86] transition-colors"
                        >
                            <GoPlus size={19} />
                        </button>
                        <button
                            onClick={() => handleDecrease(setStopPriceCtrl, stopPriceCtrl)}
                            className="text-white py-3 px-3 active:text-[#004f86] transition-colors"
                        >
                            <FiMinus size={19} />
                        </button>
                    </div>
                </div>
            </div>
            {/* ) : (
                <div className='mb-1'>
                    <p className='text-sm font-medium text-white mb-1'>
                        Percentage
                    </p>
                    <div className="flex group border border-transparent hover:border-[#2c3354] rounded-xl overflow-hidden transition-colors">

                        <input
                            type='number'
                            value={percentageInput}
                            onChange={(e) => setPercentageInput(e.target.value)}
                            className="w-full py-3 px-4 text-white bg-[#171d33] focus:outline-none custom-number-input"
                        />
                        <div className="flex items-center justify-center bg-[#2c3354]">

                            <button
                                onClick={() =>
                                    handleIncrease(
                                        setPercentageInput,
                                        percentageInput
                                    )
                                }
                                className="text-white py-3 px-3 active:text-[#004f86] transition-colors"

                            >
                                <GoPlus size={19} />
                            </button>
                            <button
                                onClick={() =>
                                    handleDecrease(
                                        setPercentageInput,
                                        percentageInput
                                    )
                                }
                                className="text-white py-3 px-3 active:text-[#004f86] transition-colors"

                            >
                                <FiMinus size={19} />
                            </button>

                        </div>
                    </div>
                </div>
            )} */}

            <div>
                <p className='text-sm font-medium text-white mb-1'>
                    {t("calculator.currentPrice")}
                </p>
                <div className="flex group border border-transparent hover:border-[#2c3354] rounded-xl overflow-hidden transition-colors relative">

                    <input
                        type='number'
                        value={currentPriceCtrl}
                        onChange={(e) => setCurrentPriceCtrl(e.target.value)}
                        className="w-full py-3 px-4 text-white bg-[#171d33] focus:outline-none custom-number-input"
                    />
                    {isNaN(currentPricePercentage) ? null :
                        <p
                            className={`absolute right-[21%] top-[26%] transform text-sm font-medium ${currentPricePercentage < 0 ? 'text-red-500' : 'text-green-500'
                                }`}
                        >
                            <span className="flex items-center">
                                {currentPricePercentage < 0 ? (
                                    <FaArrowDown size={14} className="mr-1" />
                                ) : (
                                    <FaArrowUp size={14} className="mr-1" />
                                )}
                                {Math.abs(currentPricePercentage)}%
                            </span>
                        </p>
                    }

                    <div className="flex items-center justify-center bg-[#2c3354]">



                        <button
                            onClick={() =>
                                handleIncrease(
                                    setCurrentPriceCtrl,
                                    currentPriceCtrl
                                )
                            }
                            className="text-white py-3 px-3 active:text-[#004f86]  transition-colors"
                        >
                            <GoPlus size={19} />
                        </button>
                        <button
                            onClick={() =>
                                handleDecrease(
                                    setCurrentPriceCtrl,
                                    currentPriceCtrl
                                )
                            }
                            className="text-white py-3 px-3 active:text-[#004f86]  transition-colors"
                        >
                            <FiMinus size={19} />
                        </button>
                    </div>
                </div>
            </div>

            {/* Results */}
            <div className='mt-6'>
                <h2 className='text-[1.4rem] font-semibold text-[#00baff] mb-3 tracking-wide border-b border-[#2c3354] pb-1'>
                    {t("calculator.title")}
                </h2>


                <p
                    className={`text-base font-medium flex items-center gap-1 mb-2`}
                >
                    <span className='text-[#00ffc3]'>
                        {t("calculator.riskPercentage")}:
                    </span>{" "}
                    <span className={`flex items-center ${riskPercent < 0 ? 'text-red-500' : 'text-green-500'
                        }`}>
                        {riskPercent < 0 ? (
                            <FaArrowDown size={14} className="mr-1" />
                        ) : (
                            <FaArrowUp size={14} className="mr-1" />
                        )}
                        {Math.abs(riskPercent)}%
                    </span>
                </p>
                <p
                    className={`text-base font-medium flex items-center gap-1 mb-2`}
                >
                    <span className='text-[#00ffc3]'>
                        {t("calculator.currentPricePercentage")}:
                    </span>{" "}
                    <span className={`flex items-center ${currentPricePercentage < 0 ? 'text-red-500' : 'text-green-500'
                        }`}>
                        {currentPricePercentage < 0 ? (
                            <FaArrowDown size={14} className="mr-1" />
                        ) : (
                            <FaArrowUp size={14} className="mr-1" />
                        )}
                        {Math.abs(currentPricePercentage)}%
                    </span>
                </p>

                {calculationMode === 'Percentage' && (
                    <>
                        <p className='text-base font-medium text-white mb-3'>
                            <span className='font-medium text-[#00ffc3]'>
                                {t("calculator.riskPrice")}:
                            </span>{" "}
                            {risk}
                        </p>
                    </>
                )}

                {results.length > 0 && (
                    <div className="overflow-x-auto rounded-lg border border-[#2c3354]">
                        <table className='w-full border-collapse'>
                            <thead>
                                <tr className='bg-[#004f86] text-white text-sm font-semibold'>
                                    <th className='p-3 text-left'>
                                        {t("calculator.percentRisk")}
                                    </th>
                                    <th className='p-3 text-left'>
                                        {t("calculator.newShares")}
                                    </th>
                                    <th className='p-3 text-left'>
                                        {t("calculator.gain")}
                                    </th>
                                    <th className='p-3 text-left'>
                                        {t("calculator.loss")}                          </th>
                                    <th className='p-3 text-left'>
                                        {t("calculator.net")}
                                    </th>
                                    <th className='p-3 text-left'>
                                        {t("calculator.netPercent")}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {results.map((result, index) => (
                                    <tr
                                        key={index}
                                        className={`${index % 2 === 0 ? 'bg-[#171d33]' : 'bg-[#1e2544]'
                                            } text-white text-sm hover:bg-[#2c3354] transition`}
                                    >
                                        <td className='p-3'>{result.onPercentRisk}%</td>
                                        <td className='p-3'>{result.newShares}</td>
                                        <td className='p-3'>{result.gain}</td>
                                        <td className='p-3'>{result.loss}</td>
                                        <td className='p-3'>{result.net}</td>
                                        <td className='p-3'>{result.netPercent}%</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>

            <button
                className='w-full mt-2 bg-[#004f86] text-white py-2 mb-1 rounded-full flex items-center justify-center gap-2 transition-opacity ease-linear hover:opacity-75 text-base font-medium'
                onClick={resetAllInput}
            >
                {t("calculator.startOver")}    <IoReload />
            </button>
        </>
    )
}

export default RiskFinance
